import { useSelector } from 'react-redux';
import Spacer from '@/common/Spacer';
import ShippingTooltip from '@/vdp/EarliestDelivery/PickupAndDelivery/ShippingTooltip';
import Sections from '~/constants/sections';
import {
  getIsPartnerVehicle,
  getShouldHideDeliveryPickup,
  getTransitChargeInfo
} from '~/selectors';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import DeliveryBanner from './DeliveryBanner';
import {
  DeliveryAndPickupWrapper,
  TransitCharge
} from './LiteTextBoxes.styles';
import PickupBanner from './PickupBanner';

const DeliveryAndPickupLite = () => {
  const { data: transitCharge } = useSelector(getTransitChargeInfo);
  const shouldHideSection = useSelector(getShouldHideDeliveryPickup);
  const isPartner = useSelector(getIsPartnerVehicle);

  return shouldHideSection ? null : (
    <div
      className="w-full bg-white px-20 py-12 m:px-32"
      id={Sections.EarliestDelivery}
    >
      <DeliveryAndPickupWrapper>
        <PickupBanner />
        <DeliveryBanner />
      </DeliveryAndPickupWrapper>
      <TransitCharge>
        {transitCharge > 0 ? (
          <div className="flex items-center justify-center">
            {`$${formatAndDropDecimal(transitCharge)} Shipping`}
            <ShippingTooltip
              transitCharge={formatAndDropDecimal(transitCharge)}
            />
          </div>
        ) : (
          <Spacer size={1} />
        )}
      </TransitCharge>
      {isPartner ? (
        <p className="w-full px-36 text-center text-grey-5 tl-body-xs m:tl-body-s">
          This partner vehicle may be for sale elsewhere. Availability will be
          confirmed at time of purchase.
        </p>
      ) : null}
    </div>
  );
};

export default withErrorBoundary(DeliveryAndPickupLite);
